import { render, staticRenderFns } from "./ClearPin.vue?vue&type=template&id=ceb3059a&scoped=true&lang=pug&"
import script from "./ClearPin.vue?vue&type=script&lang=js&"
export * from "./ClearPin.vue?vue&type=script&lang=js&"
import style0 from "./ClearPin.vue?vue&type=style&index=0&id=ceb3059a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb3059a",
  null
  
)

export default component.exports